import htmx from 'htmx.org/dist/htmx.esm.js'

window.htmx = htmx
